<script lang="ts" setup>
import { ref } from 'vue';


const showTooltip = ref(false);

let props = defineProps({
    text: {
        type: String,
        required: true
    },
    position: {
        type: String,
        required: false,
        default: 'top'
    },
    showOn: {
        type: String,
        required: false,
        default: 'hover' // or 'click'
    }
});
</script>
<template>
    <div
       
        :class="`tooltip--${position}`"
        @mouseenter="showOn === 'hover' ? showTooltip = true : null"
        @mouseleave="showOn === 'hover' ? showTooltip = false : null"
        @click="showOn === 'click' ? showTooltip = !showTooltip : null"
    >
        <slot />
        <div v-if="showTooltip" class="tooltip__text text-rothcoWhite">
            {{ text }}
        </div>
    </div>
</template>
<style lang="scss" scoped>
.tooltip {
    position: relative;
    display: inline-block;

    &__text {
        visibility: visible;
        width: max-content;
        max-width: 200px;
        background-color: #555;
        color: #fff;
        text-align: center;
        border-radius: 6px;
        padding: 5px 10px;
        position: absolute;
        z-index: 1;
        bottom: 125%; /* Position the tooltip above the text */
        left: 50%;
        transform: translateX(-50%);
        opacity: 0.9;
        transition: opacity 0.3s;

        /* Arrow */
        &::after {
            content: "";
            position: absolute;
            top: 100%; /* At the bottom of the tooltip */
            left: 50%;
            margin-left: -5px;
            border-width: 5px;
            border-style: solid;
            border-color: #555 transparent transparent transparent;
        }
    }

    &--top .tooltip__text {
        bottom: 125%;
        left: 50%;
        transform: translateX(-50%);
    }

    &--bottom .tooltip__text {
        top: 125%;
        left: 50%;
        transform: translateX(-50%);
    }

    &--left .tooltip__text {
        top: 50%;
        right: 125%;
        transform: translateY(-50%);
    }

    &--right .tooltip__text {
        top: 50%;
        left: 125%;
        transform: translateY(-50%);
    }
}
</style>